// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__DJqxF","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__1K8BM"};